<template
>
    <div class="pa-5 compact-form">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Company name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeOnboarding.name"
                        @input="updateField($event, 'name')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Legal type" | t }}</v-col>
            <v-col cols="6">
                <v-select
                        :value="activeOnboarding.legal_type"
                        :items="['private', 'company']"
                        @input="updateField($event, 'legal_type')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Registry code" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeOnboarding.identification_code"
                        @input="updateField($event, 'identification_code')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Status" | t }}</v-col>
            <v-col cols="6">
                <v-select
                        :value="activeOnboarding.status"
                        :items="['completed', 'confirmed', 'failed', 'pending']"
                        @input="updateField($event, 'status')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Contact address" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeOnboarding.contact_address"
                        @input="updateField($event, 'contact_address')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col cols="6">
                <v-select
                        :value="activeOnboarding.country"
                        :items="['EE', 'LV', 'LT']"
                        @input="updateField($event, 'country')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Field of activity" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeOnboarding.field_of_activity"
                        @input="updateField($event, 'field_of_activity')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Email" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeOnboarding.email"
                        @input="updateField($event, 'email')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Phone number" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeOnboarding.phone_nr"
                        @input="updateField($event, 'phone_nr')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Postback method" | t }}</v-col>
            <v-col cols="6">
                <v-select
                        :value="activeOnboarding.postback_method"
                        :items="['GET', 'POST']"
                        @input="updateField($event, 'postback_method')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Postback URL" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeOnboarding.postback_url"
                        @input="updateField($event, 'postback_url')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
    name: "general-info-edit-tab",
    computed: {
        ...mapState('onboarding', ['activeOnboarding'])
    },
    methods: {
        ...mapMutations('onboarding', ['updateOnboardingProperty']),
        updateField(value, field) {
            this.updateOnboardingProperty({prop: field, value: value});
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
